"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_url_service_1 = require("./base.url.service");
var UrlService = /** @class */ (function (_super) {
    tslib_1.__extends(UrlService, _super);
    function UrlService(moduleName, typeName, baseUrl) {
        var _this = _super.call(this) || this;
        _this.moduleName = moduleName;
        _this.typeName = typeName;
        _this.baseUrl = baseUrl;
        _this.URL = baseUrl[_this.moduleName];
        _this.baseURL = "" + _this.URL + (_this.moduleName != "" ? "/" : "") + _this.moduleName + (_this.typeName != "" ? "/" : "") + _this.typeName;
        return _this;
    }
    return UrlService;
}(base_url_service_1.BaseUrlService));
exports.UrlService = UrlService;
//# sourceMappingURL=url.service.js.map